import React from 'react'

interface ComponentProps {
  children: React.ReactNode | undefined
}

function CarouselItem({ children }: ComponentProps) {
  return <div className='carousel-item'>{children}</div>
}

export default CarouselItem
